import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { WebPage } from '../models/WebPage';
import { ApiProvider } from '../providers/api.provider';
import { HttpErrorResponse } from '@angular/common/http';
import { Title, Meta } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class WebpageService {

  private currentWebPageSubject: BehaviorSubject<WebPage>;
  public currentWebPage: Observable<WebPage>;
  constructor(private apiProvider: ApiProvider,
    private titleService: Title, 
    private metaService: Meta,) { 
    this.currentWebPageSubject = new BehaviorSubject<WebPage>(null);
  }
  
  public get currentWebPageValue(): WebPage {
    return this.currentWebPageSubject.value;
  }

  async initialiseWebPage(WebPageID:number, languageID: number) {
    await this.apiProvider.WebPage(WebPageID, languageID).subscribe(async (webPages: WebPage) => {
      this.currentWebPageSubject = await new BehaviorSubject<WebPage>(webPages);
      this.currentWebPage = this.currentWebPageSubject.asObservable();
      
      if(this.currentWebPageValue.WebPageTranslations[0].TitleReferencement == ""){        
        this.titleService.setTitle(this.currentWebPageValue.WebPageTranslations[0].Title + " | Nationex");
      }
      else{
        this.titleService.setTitle(this.currentWebPageValue.WebPageTranslations[0].TitleReferencement + " | Nationex");
      }
      if(this.currentWebPageValue.WebPageTranslations[0].DescriptionReferencement == ""){  
        this.metaService.addTags([{name: 'description', content: this.currentWebPageValue.WebPageTranslations[0].ShortDescription}]);      
      }
      else{
        this.metaService.addTags([{name: 'description', content: this.currentWebPageValue.WebPageTranslations[0].DescriptionReferencement}]); 
      }
    }, (err: HttpErrorResponse) => {
      this.currentWebPageSubject.next(null);
    });
  }
}
